<template>
    <div class="sec-cont">
        <Head :title="__('Users')" />
        <div class="mb-6 flex flex-col md:flex-row gap-3 justify-between items-center ticket-filters">
            <search-input v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset"></search-input>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6">{{ __('Sr No') }}</th>
                    <th class="pb-4 pt-6 px-6">{{ __('Name') }}</th>
                    <th class="pb-4 pt-6 px-6">{{ __('Subject') }}</th>
                    <th class="pb-4 pt-6 px-6">{{ __('Priority') }}</th>
                    <th class="pb-4 pt-6 px-6">{{ __('Assigned To') }}</th>
                    <th class="pb-4 pt-6 px-6">{{ __('Department') }}</th>

                    <th class="pb-4 pt-6 px-6 flex"
                        v-click-outside="()=>{visible.menu_recent = false}"
                        @click="visible['menu_recent'] = !visible['menu_recent']"
                        >
                        {{ __('Ticket Status') }}  <icon class="ml-2 w-4 h-4 text-black" name="arrow-down"/>
                    </th>
                    <ul v-if="visible.menu_recent" class="menu-dropdown">
                        <li
                            v-for="status in transformedStatusList"
                            :key="status.label"
                            :class="{ 'highlighted': selectedStatus === status.label }"
                            @click="selectStatus(status.value)">
                            {{ status.label }}
                        </li>
                    </ul>
                    <th class="pb-4 pt-6 px-6">{{ __('Action ') }}</th>
                </tr>
                <tr v-for="(ticket, index) in tickets.data" :key="tickets.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" tabindex="-1">
                            {{ index + 1 }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" tabindex="-1">
                            {{ ticket.name }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" tabindex="-1">
                            {{ ticket.subject }}
                        </Link>
                    </td>
                    <td class="border-t capitalize">
                        <Link class="flex items-center px-6 py-4" tabindex="-1">
                            {{ ticket.priority}}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" tabindex="-1">
                            {{ ticket.assigned_to}}
                        </Link>
                    </td>

                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" tabindex="-1">
                            {{ ticket.department}}
                        </Link>
                    </td>


                    <td class="border-t capitalize">
                        <Link class="flex items-center px-6 py-4" :class="{ 'text-red-500': ticket.status === 'closed' }" tabindex="-1">
                            {{ ticket.status}}
                        </Link>
                    </td>


                    <td class="w-px border-t flex items-center px-6 py-4 focus:text-indigo-500">
                        <Link class="btn btn-primary" :href="route('ticket.edit', { ticket: ticket.id })">
                            View
                        </Link>
                    </td>
                </tr>
                <tr v-if="tickets.data.length === 0">
                    <td class="px-6 py-4 border-t" colspan="6">No tickets found.</td>
                </tr>
            </table>
        </div>
        <pagination class="mt-6" :links="tickets.links" />
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchInput from '@/Shared/SearchInput'
import SelectInput from '@/Shared/SelectInput'

export default {
    components: {
        SearchInput,
        Head,
        Icon,
        Link,
        SelectInput,
        Pagination,
    },
    layout: Layout,
    props: {
        filters: Object,
        tickets: Object,
        statusList: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            form: {
                search: this.filters.search,
                selectedStatus: this.filters.statusList ?? null,
                status: this.status ?? null,
            },
            visible: {
                project_create: false,
                create_workspace: false,
                menu_workspace: false,
                menu_recent: false,
                menu_star: false,
                menu_create: false,
            },
            selectedStatus: '' ,
        }
    },
    computed:{
        transformedStatusList() {
            // Transform the object into an array format suitable for v-for
            return Object.entries(this.statusList).map(([value, label]) => ({
                value,
                label
            }));
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get(this.route('admin.ticketList'), pickBy(this.form), { preserveState: true })
            }, 150),
        },
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
        selectStatus(status) {
            this.form.selectedStatus = status
            this.visible.menu_recent = false; // Close the dropdown after selection
        },
    },
}
</script>
